import AuthenticationScreen from "../screens/AuthenticationScreen";
import DashboardScreen from "../screens/DashboardScreen";
import AnalyticsScreen from "../screens/AnalyticsScreen";
import LoginScreen from "../screens/LoginScreen";
import ReportsScreen from "../screens/ReportsScreen";
import AnomalyDetectionScreen from "../screens/AnomalyDetectionScreen";
import AnomalyListComponent from "../components/anomaly-detection/anomaly-list.component";
import GeolocationTrackingScreen from "../screens/GeolocationTrackingScreen";
import AnomalyDetailViewComponent from "../components/anomaly-detection/anomaly-detail-view.component";
import ActivityLogsListComponent from "../components/logs/activity-logs-list.component";
import ReportLogsDetailViewComponent from "../components/reports/report-logs/report-logs-detail-view.component";

export const routes = [

    {
        path: '/',
        name: 'LoginScreen',
        element: <LoginScreen />,
        isPrivate: false
    },
    {
        path: '/geolocation-tracking',
        name: 'DashboardScreen',
        element: <GeolocationTrackingScreen />,
        isPrivate: true
    },
    

    {
        path: '/dashboard',
        name: 'DashboardScreen',
        element: <DashboardScreen />,
        isPrivate: true
    },

    {
        path: '/authentication',
        name: 'AuthenticationScreen',
        element: <AuthenticationScreen />,
        isPrivate: true
    },

    {
        path: '/analytics',
        name: 'AnalyticsScreen',
        element: <AnalyticsScreen />,
        isPrivate: true
    },

    {
        path: '/reports/authentication-performance',
        name: 'ReportsScreen',
        element: <ReportsScreen />,
        isPrivate: true
    },

    {
        path: '/reports/anomaly-detection',
        name: 'ReportsScreen',
        element: <ReportsScreen />,
        isPrivate: true
    },

    {
        path: '/reports/geolocation-verification',
        name: 'ReportsScreen',
        element: <ReportsScreen />,
        isPrivate: true
    },

    {
        path: '/reports/product-specific-verification',
        name: 'ReportsScreen',
        element: <ReportsScreen />,
        isPrivate: true
    },

    {
        path: '/reports/user-activity',
        name: 'ReportsScreen',
        element: <ReportsScreen />,
        isPrivate: true
    },

    {
        path: '/reports/verification-frequency',
        name: 'ReportsScreen',
        element: <ReportsScreen />,
        isPrivate: true
    },

    {
        path: '/reports/audit-trail',
        name: 'ReportsScreen',
        element: <ReportsScreen />,
        isPrivate: true
    },

    {
        path: '/reports/alerts-notifications',
        name: 'ReportsScreen',
        element: <ReportsScreen />,
        isPrivate: true
    },

    {
        path: '/reports/report-logs-list',
        name: 'ReportsScreen',
        element: <ReportsScreen />,
        isPrivate: true
    },

    {
        path: '/anomaly-detection',
        name: 'AnomalyDetectionScreen',
        element: <AnomalyDetectionScreen />,
        isPrivate: true
    },

    {
        path: '/anomaly-detection/list',
        name: 'AnomalyListComponent',
        element: <AnomalyListComponent />,
        isPrivate: true
    },
    {
        path: '/geolocation-tracking',
        name: 'DashboardScreen',
        element: <GeolocationTrackingScreen />,
        isPrivate: true
    },
    
    {
        path: '/anomaly-detection/details',
        name: 'AnomalyDetailViewComponent',
        element: <AnomalyDetailViewComponent />,       
        isPrivate: true
    },

    {
        path: '/activity-logs',
        name: 'ActivityLogsListComponent',
        element: <ActivityLogsListComponent />,       
        isPrivate: true
    },

    {
        path: '/reports/report-logs-list/details',
        name: 'ReportLogsDetailViewComponent',
        element: <ReportLogsDetailViewComponent />,       
        isPrivate: true
    },
   
];